import React, { useEffect, useState } from 'react'
import DashboardHeader from './DashboardHeader';
import { Card } from '../UI/Card';
import CreateProject from './CreateProject';
import { toast } from 'react-toastify';
import { api } from '../../services/api';


const Dashboard = () => {

  const [stats, setStats] = useState({
    processing_projects: 0,
    approved_projects: 0,
    completed_projects: 0,
    rejected_projects: 0,
    total_projects: 0,
  });

  // Function to get current date in the format "18 Nov 2024 | Monday"
  const getCurrentDate = () => {
    const today = new Date();
    const day = today.getDate();
    const month = today.toLocaleString('en-GB', { month: 'short' });
    const year = today.getFullYear();
    const weekday = today.toLocaleString('en-GB', { weekday: 'long' });

    return `${day} ${month} ${year} | ${weekday}`;
};

  const [date, setDate] = useState(getCurrentDate());

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await api.dashboard.getDashboardSummary();
        if (response.data.status === 'success') {
          setStats(response.data.data);
        } else {
          toast.error('Failed to fetch stats');
        }
      } catch (error) {
        console.error('Error fetching stats:', error);
        // toast.error('Error fetching dashboard stats');
      }
    };

    fetchStats();
  }, []);

   // Updated card data with API values
   const cardData = [
    { icon: '/assets/icons/total.svg', count: stats.total_projects, name: 'Total Projects', color: '#6F65FF' },
    { icon: '/assets/icons/user.svg', count: stats.processing_projects, name: 'Processing Projects', color: '#CC6DFB' },
    { icon: '/assets/icons/pending.svg', count: stats.completed_projects, name: 'Completed Projects', color: '#FF9244' },
    { icon: '/assets/icons/approved.svg', count: stats.approved_projects, name: 'Approved Projects', color: '#00CD9D' },
    { icon: '/assets/icons/rejected.svg', count: stats.rejected_projects, name: 'Rejected Projects', color: '#FF6565' },
  ];

  return (
        <div className='dashboard pt-4 h-100'>
            <DashboardHeader date={date} />
            <div className='overview-wrapper'>
              <div className='overview-container'>
                {cardData.map((card, index) => (
                  <Card
                    key={index}
                    icon={card.icon}
                    count={card.count}
                    name={card.name}
                    color={card.color}
                  />
                ))}
              </div>
              <CreateProject />
            </div>
            
        </div>
        
  )
}

export default Dashboard